module.exports = __webpack_public_path__ + "static/media/banner3-mob.dab86b2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/banner3-mob.png
// module id = 42
// module chunks = 0